import React from 'react';

interface Tab {
  key: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  selectedTabKey: string;
  onTabChange: (key: string) => void;
  children: React.ReactNode;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  selectedTabKey,
  onTabChange,
  children,
}) => {
  return (
    <div>
      <div className="mb-4 flex gap-6 border-b border-gray-200">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`border-b-2 px-4 py-2 text-sm font-medium transition-colors duration-150 focus:outline-hidden ${
              selectedTabKey === tab.key
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-600 hover:text-blue-600'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>{children}</div>
    </div>
  );
};

export default Tabs;
